import { render, staticRenderFns } from "./FiltersComponent.vue?vue&type=template&id=8c547650&scoped=true"
import script from "./FiltersComponent.vue?vue&type=script&lang=ts"
export * from "./FiltersComponent.vue?vue&type=script&lang=ts"
import style0 from "./FiltersComponent.vue?vue&type=style&index=0&id=8c547650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c547650",
  null
  
)

export default component.exports